import LoginView from "../views/LoginView.vue";
import ResetPasswordView from "../views/ResetPasswordView.vue";

const routes = [
  {
    path: "/",
    name: "Login",
    component: LoginView,
  },
    {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPasswordView,
  },
];

export default routes;
